import type { FC, ReactNode } from 'react';
import type { VariantProps } from 'class-variance-authority';

import { sidebarHeaderClasses, sidebarHeaderTitleClasses } from './classes';

interface SidebarHeaderProps extends VariantProps<typeof sidebarHeaderClasses> {
  title: string;
  actions?: ReactNode;
  className?: string;
}

export const SidebarHeader: FC<SidebarHeaderProps> = ({ title, actions, className, withBorder }) => {
  return (
    <div className={sidebarHeaderClasses({ withBorder, className })}>
      <div className="flex flex-col">
        <p className={sidebarHeaderTitleClasses()}>{title}</p>
      </div>
      {actions}
    </div>
  );
};
